import {Params} from '@feathersjs/feathers'

import {ProviderId, Shipping, ShippingId, ShippingWithCarrier} from '../../types'

import * as feathersService from '../feathers'

export type ShippingRequest = Omit<Shipping, 'id'>

export const RESOURCE = 'shipping'

const get = async <T = Shipping>(params?: Params) => feathersService.find<T>(RESOURCE, params)

export const getByProvider = async (provider: ProviderId, params?: Params) => {
  const parameters = {
    ...params,
    query: {
      ...params?.query,
      provider,
      $modify: 'includeCarrier',
    },
  }
  return get<ShippingWithCarrier>(parameters)
}

export const getById = async (id: ShippingId) => feathersService.get<Shipping>(RESOURCE, id)

export const create = async (payload: ShippingRequest) =>
  feathersService.create<Shipping, ShippingRequest>(RESOURCE, payload)

export const createMultiple = async (payload: ShippingRequest[]) =>
  payload.length > 0
    ? feathersService.createMultiple<Shipping, ShippingRequest>(RESOURCE, payload)
    : Promise.resolve([])

export const update = async (payload: Shipping, id: ShippingId) =>
  feathersService.update<Shipping>(RESOURCE, id, payload)

export const updateMultiple = async (payload: Shipping, ids: ShippingId[]) =>
  Promise.all(ids.map(id => update(payload, id)))

export const patch = async (payload: Partial<ShippingRequest>, id: ShippingId) =>
  feathersService.patch<Shipping>(RESOURCE, id, payload)

export const patchMultiple = async (payload: Partial<ShippingRequest>, ids: ShippingId[]) =>
  Promise.all(ids.map(id => patch(payload, id)))

export const remove = async (id: ShippingId) => feathersService.remove<Shipping>(RESOURCE, id)

export const removeMultiple = async (ids: ShippingId[]) => Promise.all(ids.map(id => remove(id)))
